function applyQuantityLimit() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      cart.items.forEach(function (item) {
        const inputSelector = `input[data-id='${item.key}']`;
        const $input = $(inputSelector);
        const $wrapper = $input.closest('.t4s-quantity-wrapper');
        const $plusBtn = $wrapper.find('.t4s-quantity-selector.is--plus');

        const isRestrictedProduct =
          item.product_id === 10037920694588 || item.product_id === 10037921055036;

        if (isRestrictedProduct) {
          if (item.quantity > 3) {
            // Auto-correct quantity to 3
            fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: item.key,
                quantity: 1
              })
            })
              .then(() => {
                console.log(`Corrected quantity to 3 for product ${item.product_id}`);
                location.reload(); // Refresh page to reflect update
              })
              .catch(err => console.error('Error correcting quantity:', err));
          } else {
            // If quantity is 3 or more, disable the + button and show message
            if (item.quantity >= 1) {
              $plusBtn.prop('disabled', true);
              if ($wrapper.find('.qty-limit-msg').length === 0) {
                $input.after('<div class="qty-limit-msg" style="color:red;font-size:13px;margin-top:4px;">Max 1 allowed</div>');
              }
            } else {
              $plusBtn.prop('disabled', false);
              $wrapper.find('.qty-limit-msg').remove();
            }
          }
        } else {
          // Not restricted product
          $plusBtn.prop('disabled', false);
          $wrapper.find('.qty-limit-msg').remove();
        }
      });
    });
}

$(document).ready(function () {
  applyQuantityLimit();

  $(document).on('click', '.t4s-quantity-selector', function () {
    setTimeout(() => {
      applyQuantityLimit();
    }, 300);
  });

  let qtyChangeTimeout;

  $(document).on('change', '.t4s-quantity-input', function () {
    const $input = $(this);
    const lineItemKey = $input.data('id');

    clearTimeout(qtyChangeTimeout);

    qtyChangeTimeout = setTimeout(() => {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const item = cart.items.find(i => i.key === lineItemKey);

          if (item && (item.product_id === 10037920694588 || item.product_id === 10037921055036)) {
            if (item.quantity > 2) {
              fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  id: lineItemKey,
                  quantity: 1
                })
              })
                .then(res => res.json())
                .then(() => {
                  console.log('Quantity reset to 3 for restricted product.');
                  location.reload();
                })
                .catch(err => {
                  console.error('Error updating cart quantity:', err);
                });
            } else {
              const $wrapper = $input.closest('.t4s-quantity-wrapper');
              const $plusBtn = $wrapper.find('.t4s-quantity-selector.is--plus');

              if (item.quantity >= 1) {
                $plusBtn.prop('disabled', true);
                if ($wrapper.find('.qty-limit-msg').length === 0) {
                  $input.after('<div class="qty-limit-msg" style="color:red;font-size:13px;margin-top:4px;">Max 1 allowed</div>');
                }
              } else {
                $plusBtn.prop('disabled', false);
                $wrapper.find('.qty-limit-msg').remove();
              }
            }
          }
        })
        .catch(error => {
          console.error('Error fetching cart:', error);
        });
    }, 500);
  });
});
